import CLPCustomizeStep from "containers/OnboardingPlaybook/CLPCustomizeStep"
import CLPUrlStep from "containers/OnboardingPlaybook/CLPUrlStep"
import OnboardingPlaybookLoadingStep from "layouts/OnboardingPlaybookLoadingStep"
import ClpWoohooStep from "containers/OnboardingPlaybook/ClpWoohooStep"
import CLPSubdomainStep from "containers/OnboardingPlaybook/CLPSubdomainStep"


export default Object.freeze([
  {
    route: '/customize',
    component: CLPCustomizeStep,
  },
  {
    route: '/subdomain',
    component: CLPSubdomainStep,
  },
  {
    route: '/url',
    component: CLPUrlStep,
  },
  {
    route: '/loading',
    component: OnboardingPlaybookLoadingStep,
  },
  {
    route: '/woohoo',
    component: ClpWoohooStep,
  }
])



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/OnboardingCLPFlow/routes.js